import { render, staticRenderFns } from "./manageIosTier.vue?vue&type=template&id=2dd3ecb5&"
import script from "./manageIosTier.vue?vue&type=script&lang=js&"
export * from "./manageIosTier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports